import { BreadCrumbs } from "shared/components/BreadCrumbs";

export const Header = () => {
  return (
    <div>
      <div className="flex items-center justify-between border-b border-alpha-40 px-3 md:px-6 pb-3">
        <BreadCrumbs
          crumbs={[
            { title: "Settings", href: "/settings" },
            { title: "Billing", href: "/settings/statements" }
          ]}
        />
      </div>
      <div className="p-6">
        <h1 className="text-xl font-bold text-content-1000">Billing</h1>
      </div>
    </div>
  );
};
